import axios from "axios"

/**
 * @description: 埋点ajax
 * @param {Number} 数据来源 origin 填 5 - 国际疫情大事记H5
 * @param {Number} action  => 1 - 访问首页；12 - 点击倒序按钮；13 - 点击顺序按钮；14 - 点击更多疫情数据；15 - 桑基图tab点击；16 - 桑基图下滑；17 - 时间轴tab点击；18 - 时间轴下滑；19 - 国家点击；
 * @param {String} optionName: 国家名
 */

const { NODE_ENV } = process.env
// console.log(NODE_ENV)
const urlArr = {
  production: "https://caiji.nfapp.southcn.com/analytics/sendRecord",
  test: "https://testcaiji.nfapp.southcn.com/analytics/sendRecord",
  development: "https://testcaiji.nfapp.southcn.com/analytics/sendRecord"
}
const BASE_URL = urlArr[NODE_ENV] || "https://testcaiji.nfapp.southcn.com/analytics/sendRecord"

const savePoint = params => {
  axios
    .get(BASE_URL, {
      params
    })
    .then(res => res.data.data)
}
export { savePoint, BASE_URL }
